//--------------------------------------------------
// imported classes
//--------------------------------------------------
const Invitation = require('@/tbs/model/to/Invitation')
const ClassFunc = require('@/tbs/util/ClassFunc')

/**
 * The Player class works as the player translator.
 */
const tbs_model_to_Referee = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, Invitation, arguments);
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_to_Referee.prototype = {
    'match-referee': '赛事裁判',
    'referee-empty-hint': '暂无裁判员，新建裁判员',
    'referee-name-required': '请填写裁判名称',
    'referee-name-label': '裁判名称',
    'referee-name-placeholder': '裁判名称',
    'referee-avatar-label': '照片（可选）',
    'referee-avatar': '照片',
    'referee-avatar-placeholder': '标准头像照，建议图片大小300X400 PX',
    'referee-phone-label': '手机（可选）',
    'referee-phone': '手机',
    'referee-grade-label': '级别（可选）',
    'referee-grade': '级别',
    'referee-grade-options-0': '其他',
    'referee-grade-options-1': '十一人制国际级',
    'referee-grade-options-2': '十一人制国际助理级',
    'referee-grade-options-3': '十一人制国家级',
    'referee-grade-options-4': '十一人制一级',
    'referee-grade-options-5': '十一人制二级',
    'referee-grade-options-6': '十一人制三级',
    'referee-grade-options-7': '五人制国际级',
    'referee-grade-options-8': '五人制国际助理级',
    'referee-grade-options-9': '五人制国家级',
    'referee-grade-options-10': '五人制一级',
    'referee-grade-options-11': '五人制二级',
    'referee-grade-options-12': '五人制三级',
    'delete-referee': '删除裁判员',
    'delete-referee-confirm-message': '确认删除该裁判员，无法进行还原',
    'shift-match-referee': '移出赛事裁判员',
    'shift-match-referee-confirm-message': '确认在当前赛事中移出该裁判员',
    'import-match-referee': '导入赛事裁判员',
}

//--------------------------------------------------
// extends the Invitation
//--------------------------------------------------
ClassFunc.extend(tbs_model_to_Referee, Invitation);

module.exports = tbs_model_to_Referee